import React, { createContext, useContext, useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const FeaturesContext = createContext({});

export const FeaturesProvider = ({ children }) => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/admin/settings/features/public`)
      .then(res => res.ok ? res.json() : [])
      .then(data => setFeatures(data))
      .catch(() => {});
  }, []);

  return <FeaturesContext.Provider value={features}>{children}</FeaturesContext.Provider>;
};

export const useFeatureIntro = (featureId, lang = 'de') => {
  const features = useContext(FeaturesContext);
  const feat = features.find(f => f.id === featureId);
  if (!feat) return { intro: '', description: '', name: '' };
  return {
    intro: lang === 'de' ? (feat.intro_de || '') : (feat.intro_en || ''),
    description: lang === 'de' ? (feat.description_de || '') : (feat.description_en || ''),
    name: lang === 'de' ? (feat.name_de || '') : (feat.name_en || ''),
  };
};

export const useFeatureFlags = (featureId) => {
  const features = useContext(FeaturesContext);
  const feat = features.find(f => f.id === featureId);
  return {
    isPremium: !!feat?.is_premium,
    superadminOnly: !!feat?.superadmin_only,
    enabled: !!feat,
  };
};

export const usePremiumFeatures = (lang = 'de') => {
  const features = useContext(FeaturesContext);
  return features
    .filter(f => f.is_premium)
    .sort((a, b) => (a.order || 99) - (b.order || 99))
    .map(f => ({
      id: f.id,
      name: lang === 'de' ? (f.name_de || '') : (f.name_en || ''),
      intro: lang === 'de' ? (f.intro_de || '') : (f.intro_en || ''),
      description: lang === 'de' ? (f.description_de || '') : (f.description_en || ''),
      icon: f.icon || 'Star',
    }));
};
